import React, { useEffect, useContext, useState, useCallback } from 'react'
import useSWR from 'swr'
import { fetchPaymentDetails } from '@library/api-payment'
import { Accordion, Text } from '@gousto-internal/citrus-react'
import { AccountDetailsContext } from '../../../AccountDetailsContext'
import { RenderedTitle } from '../../RenderedTitle'
import { ActionType } from '../../../interfaces'

export const PaymentCardSection = ({ userId }: { userId?: string }) => {
  const { data } = useSWR(userId, fetchPaymentDetails)
  const [key, updateKey] = useState(Date.now())
  const { state, dispatch } = useContext(AccountDetailsContext)
  const onChangeCallback = useCallback(
    () =>
      dispatch({
        type: ActionType.RESET_CLICKED_STATE,
      }),
    [dispatch],
  )
  const initialState = state.accountOnHoldLinkClicked ? 'expanded' : undefined

  useEffect(() => {
    if (!state.accountOnHoldLinkClicked) {
      return
    }
    updateKey(Date.now())
  }, [state])

  return (
    <>
      <Accordion
        id={'payment-details-accordion'}
        key={`payment-card-key-${key}`}
        onChange={onChangeCallback}
        initialState={initialState}
        title={(isExpanded) => {
          switch (data?.method) {
            case 'card':
              const paymentCardNumber = data?.details.number
              return (
                <RenderedTitle isExpanded={isExpanded} title="Card" iconType="credit_card">
                  <Text size={2}>{paymentCardNumber}</Text>
                </RenderedTitle>
              )
            case 'paypal':
              return (
                <RenderedTitle isExpanded={isExpanded} title="Paypal" iconType="credit_card">
                  <Text>PayPal</Text>
                </RenderedTitle>
              )
            case 'applepay':
              return (
                <RenderedTitle isExpanded={isExpanded} title="ApplePay" iconType="credit_card">
                  <Text>Apple Pay</Text>
                </RenderedTitle>
              )
            default:
              return (
                <RenderedTitle isExpanded={isExpanded} title="Card" iconType="credit_card">
                  <Text size={2}>No payment data found</Text>
                </RenderedTitle>
              )
          }
        }}
      >
        <Text>Edit Content</Text>
      </Accordion>
    </>
  )
}
